var colors = ['#ffaaaa', '#aaffaa', '#aaaaff', '#ffffaa', '#ffaaff', '#aaffff'];
var dbIdColors = {};

function getColors(length) {
  var colorArray = [];
  for (var i = 0; i < length; i++) {
    colorArray.push(colors[i % colors.length]);
  }
  return colorArray;
}

function addDbIdsToColor(ids, color) {
  if (!dbIdColors[color]) {
    dbIdColors[color] = [];
  }
  $.merge(dbIdColors[color], ids);
}

function clearDbIdColors() {
  dbIdColors = {};
}

function showChartElement(value) {
  $('#panel-content-chart__node-list').addClass('chart-active');
  hideChartElementChildren();
  var current = $('.category-tree__wrapper[data-value="' + value + '"]');
  current.addClass('chart-active-current');
  var toggler = current.find('.category-tree__children-toggler');
  var toggleId = toggler.attr('data-id');
  showChildren(toggleId);
}

function hideChartElements() {
  $('#panel-content-chart__node-list').removeClass('chart-active');
  hideChartElementChildren();
}

function hideChartElementChildren() {
  var currentToggler = $(
    '#panel-content-chart__node-list .chart-active-current .category-tree__children-toggler'
  );
  $.each(currentToggler, function (index, item) {
    hideChildren($(item).attr('data-id'));
  });
  $('#panel-content-chart__node-list .chart-active-current').removeClass(
    'chart-active-current'
  );
}

function drawChart() {
  var value = $('#panel-content-chart__charts-select').val();

  if (value) {
    $('#panel-content-chart__charts-canvas-container').addClass('chart-active');
    showChartElement(value);
  } else {
    $('#panel-content-chart__charts-canvas-container').removeClass(
      'chart-active'
    );
    hideChartElements();
    return;
  }

  $('#panel-content-chart__charts-canvas').remove();
  $('#panel-content-chart__charts-canvas-container').append(
    $('<canvas id="panel-content-chart__charts-canvas"/>')
  );

  var ctx = document
    .getElementById('panel-content-chart__charts-canvas')
    .getContext('2d');

  var data = selectData[value];

  var chartLabels = [];
  var chartData = [];

  var sortedObj = Object.entries(data.children).sort(
    (a, b) => b[1].ids.length - a[1].ids.length
  );

  $.each(sortedObj, function (name, childData) {
    chartLabels.push(childData[0]);
    chartData.push(childData[1].ids.length);
  });

  new Chart(ctx, {
    type: 'doughnut',
    data: {
      labels: chartLabels,
      datasets: [
        {
          data: chartData,
          backgroundColor: getColors(chartLabels.length),
          borderColor: '#eee',
          borderWidth: 2
        }
      ]
    },
    options: {
      legend: {
        display: false
      },
      onClick: function (evt, item) {
        var value = $('#panel-content-chart__charts-select').val();
        if (value && item[0] && item[0]._model && selectData[value]) {
          var label = item[0]._model.label;
          var ids = selectData[value].children[label].ids;
          var color = item[0]._model.backgroundColor;
          clearAllNodes();
          selectPanelListItems(viewer, null, ids, color);
        }
      }
    }
  });
}

// Change color
// https://adndevblog.typepad.com/cloud_and_mobile/2015/12/change-color-of-elements-with-view-and-data-api.html

var colorOverlayName = 'temp-material-overlay';
var colorOverlays = {};

function addMaterial(color) {
  if (!colorOverlays[color]) {
    var material = new THREE.MeshPhongMaterial({
      color: color,
      opacity: 1,
      transparent: false,
      flatShading: true,
      combine: THREE.AddOperation,
      precision: 'lowp'
    });

    // TODO geht auch ohne transparenz ??

    viewer.impl.createOverlayScene(
      colorOverlayName + '-' + color,
      material,
      material
    );
    colorOverlays[color] = material;
  }
}

var coloredMaterial = {};

function setColorMaterial(objectIds, color) {
  addMaterial(color);

  if (!coloredMaterial[color]) {
    coloredMaterial[color] = [];
  }
  $.merge(coloredMaterial[color], objectIds);

  for (var i = 0; i < objectIds.length; i++) {
    var dbid = objectIds[i];

    var it = viewer.model.getData().instanceTree;
    it.enumNodeFragments(
      dbid,
      function (fragId) {
        var renderProxy = viewer.impl.getRenderProxy(viewer.model, fragId);

        renderProxy.meshProxy = new THREE.Mesh(
          renderProxy.geometry,
          renderProxy.material
        );

        renderProxy.meshProxy.matrix.copy(renderProxy.matrixWorld);
        renderProxy.meshProxy.matrixWorldNeedsUpdate = true;
        renderProxy.meshProxy.matrixAutoUpdate = false;
        renderProxy.meshProxy.frustumCulled = false;

        viewer.impl.addOverlay(
          colorOverlayName + '-' + color,
          renderProxy.meshProxy
        );
        viewer.impl.invalidate(true);
      },
      false
    );
  }
}

function restoreAllColorMaterial() {
  $.each(coloredMaterial, function (color, dbIds) {
    restoreColorMaterial(color);
    delete coloredMaterial[color];
    colorOverlays[color] && delete colorOverlays[color];
  });
}

function restoreColorMaterial(color) {
  viewer.impl.clearOverlay(colorOverlayName + '-' + color);
}
